import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Sparkle, User, FileText } from "@phosphor-icons/react";
import ProposalCard from "./ProposalCard";
import CustomTableCard from "./CustomTableCard";

const stripProposal = (text) =>
  (text || "")
    .replace(/```json\s*\{[\s\S]*?"type"\s*:\s*"(proposal|custom_table)"[\s\S]*?\}\s*```/gi, "")
    .trim();

export default function ChatMessage({ msg, streaming, onSendToCalculator, onSaveToHistory, onSaveCustom }) {
  const isUser = msg.role === "user";
  const body = isUser ? msg.content : stripProposal(msg.content);
  const uniqueSources = [];
  (msg.sources || []).forEach((s) => {
    if (!uniqueSources.includes(s.filename)) uniqueSources.push(s.filename);
  });
  return (
    <div
      className={`flex gap-3 ${isUser ? "justify-end" : "justify-start"}`}
      data-testid={`chat-msg-${msg.role}-${msg.id || "streaming"}`}
    >
      {!isUser && (
        <div className="w-8 h-8 rounded bg-violet-600 text-white flex items-center justify-center shrink-0 mt-1">
          <Sparkle size={16} weight="fill" />
        </div>
      )}
      <div className={`max-w-[85%] ${isUser ? "order-first" : ""}`}>
        <div
          className={`rounded-lg px-4 py-3 text-sm leading-relaxed ${
            isUser
              ? "bg-[#0A3F9A] text-white"
              : "bg-white border border-slate-200 text-slate-800 shadow-sm"
          }`}
        >
          {isUser ? (
            <div className="whitespace-pre-wrap">{body}</div>
          ) : (
            <div className="prose prose-sm prose-slate max-w-none prose-table:text-xs prose-th:px-2 prose-td:px-2 prose-headings:mt-3 prose-headings:mb-1">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{body || (streaming ? "…" : "")}</ReactMarkdown>
              {streaming && <span className="inline-block w-2 h-4 bg-violet-500 animate-pulse align-middle ml-0.5" />}
            </div>
          )}
        </div>
        {!isUser && !streaming && (
          <div className="mt-1.5 flex items-center gap-3 flex-wrap text-[11px] text-slate-500">
            {msg.model_label && (
              <span className="inline-flex items-center gap-1 bg-violet-50 text-violet-700 border border-violet-200 px-1.5 py-0.5 rounded font-semibold" data-testid="msg-model-label">
                <Sparkle size={10} weight="fill" /> {msg.model_label}
              </span>
            )}
            {uniqueSources.length > 0 && (
              <span className="inline-flex items-center gap-1" data-testid="msg-sources">
                <FileText size={11} /> Sumber: {uniqueSources.join(", ")}
              </span>
            )}
          </div>
        )}
        {!isUser && !streaming && msg.proposal && (
          <ProposalCard
            proposal={msg.proposal}
            onSendToCalculator={() => onSendToCalculator(msg)}
            onSaveToHistory={() => onSaveToHistory(msg)}
          />
        )}
        {!isUser && !streaming && !msg.proposal && msg.custom_table && (
          <CustomTableCard table={msg.custom_table} onSave={() => onSaveCustom(msg)} />
        )}
      </div>
      {isUser && (
        <div className="w-8 h-8 rounded bg-slate-200 text-slate-600 flex items-center justify-center shrink-0 mt-1">
          <User size={16} weight="duotone" />
        </div>
      )}
    </div>
  );
}
